import {
  FormHintExplanation,
  HissanType,
  HissanWidget,
  KeyBordType,
  Widget,
} from "../../models/contents.ts"
import {
  Button,
  Checkbox, Dialog, DialogActions, DialogTitle,
  FormControl,
  FormControlLabel,
  Grid, IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField, Typography
} from "@mui/material"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import React, {Fragment, useState} from "react"
import HintExplanationForm from "./input-widget-form/hint-explanation-form.tsx"
import {QuestionsOption} from "../misc/questions-option.tsx";
import { VoiceIdInput } from "../misc/voice-id-input.tsx"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {HintExplanationFormCopyPastePanel} from "./input-widget-form/hint-explanation-form-copy-paste-panel.tsx";

function HissanWidgetForm(props: {
    value: HissanWidget,
    onChange: (value: Widget) => void,
    isQuestion: boolean,
}) {
  const form = props.value.form
  if (form === undefined) {
    props.value.form = {
      inputs: [],
      type: "multiplication",
      input1: 0,
      input2: 0,
      answer: 0,
      is_hint_visible: false,
    }
    props.onChange(props.value)
    return <></>
  }

  const setForm = (value: HissanWidget.Form) => {
    const newValue = { ...props.value }
    newValue.form = value
    props.onChange(newValue)
  }

  const addFormTextBox = (idx: number) => {
    const newForm = { ...form }
    newForm.inputs.splice(idx + 1, 0, {
        answer: "",
        type: "number",
        suffix: "",
    })
    setForm(newForm)
  }

  const moveFormTextBox = (idx: number, direction: number) => {
    const newForm = { ...form }
    const target = newForm.inputs[idx]
    newForm.inputs[idx] = newForm.inputs[idx + direction]
    newForm.inputs[idx + direction] = target
    setForm(newForm)
  }

  const changeFormTextBox = (idx: number, value: HissanWidget.FormTextBox) => {
    const newForm = { ...form }
    newForm.inputs[idx] = value
    setForm(newForm)
  }

  const deleteFormTextBox = (idx: number) => {
    const newForm = { ...form }
    newForm.inputs.splice(idx, 1)
    setForm(newForm)
  }

  type TabKey = "base" | "textbox" | "hint"
  const [tabKey, setTabKey] = useState<TabKey>("base")
  const handleTabChange = (_event: React.SyntheticEvent, newValue: TabKey) => {
    setTabKey(newValue)
  }

  const calculateAnswer = (type: string, input1: number, input2: number): number => {
    switch (type) {
      case "multiplication":
        return input1 * input2;
      // 将来的に他の計算タイプを追加する場合はここに追加
      default:
        return 0;
    }
  }

  return (
    <>
      <Grid item xs={3}>
        <TextField fullWidth label="type" value={props.value.type} disabled={true} />
      </Grid>
      {props.isQuestion ? (
            <QuestionsOption value={props.value} onChange={props.onChange}/>
        ) : (
            <></>
        )}
      <TabContext value={tabKey}>
        <Grid item xs={12}>
          <TabList onChange={handleTabChange}>
            <Tab label="Base" value="base" />
            <Tab label="Input" value="textbox"/>
            <Tab label="Hint / Explanation" value="hint" />
          </TabList>
        </Grid>
        <Grid item xs={12}>
          <TabPanel value="base">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    label="Type"
                    value={form.type}
                    onChange={(event) => {
                      const newType = event.target.value as HissanType;
                      const newAnswer = calculateAnswer(newType, form.input1, form.input2);
                      setForm({
                        ...form,
                        type: newType,
                        answer: newAnswer,
                      })
                    }}
                  >
                    <MenuItem value="multiplication">multiplication</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={9}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.is_hint_visible}
                      onChange={(event) => {
                        setForm({
                          ...form,
                          is_hint_visible: event.target.checked,
                        })
                      }}
                    />
                  }
                  label="is hint visible"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="input1"
                  type="number"
                  value={form.input1}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const input1 = Number(event.target.value);
                    const newAnswer = calculateAnswer(form.type, input1, form.input2);
                    setForm({
                      ...form,
                      input1: input1,
                      answer: newAnswer,
                    })
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="input2"
                  type="number"
                  value={form.input2}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const input2 = Number(event.target.value);
                    const newAnswer = calculateAnswer(form.type, form.input1, input2);
                    setForm({
                      ...form,
                      input2: input2,
                      answer: newAnswer,
                    })
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="answer"
                  type="number"
                  value={form.answer}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setForm({
                      ...form,
                      answer: Number(event.target.value),
                    })
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <VoiceIdInput
                  id={props.value.id}
                  onChange={(value) => {
                    setForm({
                      ...form,
                      voice_id: value,
                    })
                  }}
                  value={props.value?.form?.voice_id ?? ""}
                />
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  label="text"
                  value={form.text ?? ""}
                  onChange={(event) => {
                    setForm({
                      ...form,
                      text: event.target.value ? event.target.value : undefined,
                    })
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.is_markdown ?? false}
                      onChange={(event) => {
                        setForm({
                          ...form,
                          is_markdown: event.target.checked,
                        })
                      }}
                    />
                  }
                  label="is markdown"
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.no_icon ?? false}
                      onChange={(event) => {
                        setForm({
                          ...form,
                          no_icon: event.target.checked,
                        })
                      }}
                    />
                  }
                  label="no icon"
                />
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="textbox">
            <Grid item xs={12} sx={{ ml: 4 }}>
              <Grid container spacing={2}>
                <Grid item>
                  <AddFormTextBox
                    idx={0}
                    addFormTextBox={addFormTextBox}
                    moveFormTextBox={moveFormTextBox}
                    itemsLength={form.inputs.length}
                  />
                </Grid>
                {form.inputs.map((input, idx) => (
                  <Fragment key={idx}>
                    <Grid item xs={12}>
                      <FormTextBoxForm
                        widgetId={props.value.id}
                        idx={idx}
                        value={input}
                        onChange={changeFormTextBox}
                        onDelete={deleteFormTextBox}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <AddFormTextBox
                        idx={idx + 1}
                        addFormTextBox={addFormTextBox}
                        moveFormTextBox={moveFormTextBox}
                        itemsLength={form.inputs.length}
                      />
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="hint">
            <Stack spacing={2}>
              <HintExplanationForm
                widgetId={`hint-${props.value.id}`}
                title="Hint"
                value={form.hint}
                onChange={(value: FormHintExplanation) => {
                  setForm({
                    ...form,
                    hint: value,
                  })
                }}
              />
              <HintExplanationForm
                widgetId={`explanation-${props.value.id}`}
                title="Explanation"
                value={form.explanation}
                onChange={(value: FormHintExplanation) => {
                  setForm({
                    ...form,
                    explanation: value,
                  })
                }}
              />
              <HintExplanationFormCopyPastePanel
                hint={form.hint}
                explanation={form.explanation}
                onPaste={(hint, explanation) => {
                  setForm({
                    ...form,
                    hint: hint,
                    explanation: explanation,
                  })
                }}
              />
            </Stack>
          </TabPanel>
        </Grid>
      </TabContext>
    </>
  )
}

function AddFormTextBox(props: {
  idx: number
  addFormTextBox: (idx: number) => void
  moveFormTextBox: (idx: number, direction: number) => void
  itemsLength: number
}) {
  return (
    <>
      <Stack direction="row">
        <Button onClick={() => props.addFormTextBox(props.idx)} sx={{ textAlign: "center" }}>
          <AddCircleOutlineIcon />
          <Typography sx={{ ml: 1 }}>Add TextBox</Typography>
        </Button>
        <IconButton
          size="small"
          color="primary"
          disabled={props.idx === 0}
          onClick={() => props.moveFormTextBox(props.idx, -1)}
          sx={{ display: props.idx === props.itemsLength ? "none" : "block" }}
        >
          <ArrowUpward />
        </IconButton>
        <IconButton
          size="small"
          color="primary"
          disabled={props.idx === props.itemsLength - 1}
          onClick={() => props.moveFormTextBox(props.idx, 1)}
          sx={{ display: props.idx === props.itemsLength ? "none" : "block" }}
        >
          <ArrowDownward />
        </IconButton>
      </Stack>
    </>
  )
}

function FormTextBoxForm(props: {
  idx: number
  widgetId: string
  value: HissanWidget.FormTextBox
  onChange: (idx: number, value: HissanWidget.FormTextBox) => void
  onDelete: (idx: number) => void
}) {
  const [open, setOpen] = useState(false)
  const form = props.value

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="answer"
            value={form.answer}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              props.onChange(props.idx, {...form, answer: event.target.value})
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl fullWidth>
            <InputLabel id={`type-${props.idx}`}>Type</InputLabel>
            <Select
              labelId={`type-${props.idx}`}
              label="Type"
              value={form.type}
              onChange={(event) => {
                props.onChange(props.idx, {...form, type: event.target.value as KeyBordType})
              }}
            >
              <MenuItem value="general">general</MenuItem>
              <MenuItem value="number">number</MenuItem>
              <MenuItem value="symbol">symbol</MenuItem>
              <MenuItem value="full">full</MenuItem>
              <MenuItem value="fraction">fraction</MenuItem>
              <MenuItem value="operations">operations</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="suffix"
            value={form.suffix ?? ""}
            onChange={(event) => {
              props.onChange(props.idx, {...form, suffix: event.target.value})
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Button onClick={() => setOpen(true)}>
            <DeleteIcon />
          </Button>
        </Grid>
      </Grid>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Delete it</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            onClick={() => {
              setOpen(false)
              props.onDelete(props.idx)
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default HissanWidgetForm
